import { useQuery } from '@tanstack/react-query'
import { queryClient } from '../App'
import { isAdmin, isDealer, isOperator } from '../services/AccountService'
import { getIncedentTypeReasons } from '../services/NewApiService'

export type MalfunctionReasonType = {
  value: string
  key: number
  requiresExplanation: boolean
}

export const useMalfunctionReasons = () => {
  return useQuery(
    {
      queryKey: ['incedent-type-reasons'],
      queryFn: () => getIncedentTypeReasons(),
      enabled: () => isOperator() || isAdmin() || isDealer(),
      staleTime: 1000000,
      placeholderData: [],
      select: (data) =>
        data.map((el) => ({
          value: el.name,
          key: el.id,
          requiresExplanation: el.requiresExplanation,
        })),
    },
    queryClient,
  )
}

export const useMalfunctionName = () => {
  const { data } = useMalfunctionReasons()

  return (reasonId: number | number[]): string =>
    data?.find((el) => el.key === reasonId)?.value ?? '-'
}
